import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTrophyStyle0 = gravityIconIndividualCss;

const GravityIconTrophy = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7b7084e491aab1a07278433bca437484eccd4afb', color: this.color, size: this.size }, h("svg", { key: '9ab1d6a96d22f9e68291f37e34daa6c43e91947d', width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '8d6ede68b5a00054a641e3006cc90f95f5aef918', fill: "currentColor", d: "M14.999 13.4c3.35-1.16 5-3.69 5-5.61a4.25 4.25 0 0 0-1.27-3.29 1.94 1.94 0 0 0-1.32-.5H6.619a2 2 0 0 0-1.35.52 4.23 4.23 0 0 0-1.27 3.23c0 2 1.22 4.43 5 5.64a12.09 12.09 0 0 0 2.25 2.89v2.22h-3.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V19a.5.5 0 0 0-.5-.5h-3.75v-2.2a11.79 11.79 0 0 0 2.25-2.9zm2.6-7.9a2.7 2.7 0 0 1 .9 2.29c0 1.11-.9 2.62-2.74 3.64.16-.699.24-1.413.24-2.13a13.16 13.16 0 0 0-.53-3.8h2.13zm-12.1 2.25a2.71 2.71 0 0 1 .92-2.25h2.11a12.77 12.77 0 0 0-.53 3.75 9.29 9.29 0 0 0 .27 2.24c-2.51-1.21-2.77-3.05-2.77-3.74z" }))));
    }
};
GravityIconTrophy.style = GravityIconTrophyStyle0;

export { GravityIconTrophy as gravity_icon_trophy };

//# sourceMappingURL=gravity-icon-trophy.entry.js.map